import { render, staticRenderFns } from "./SuccessRegister.vue?vue&type=template&id=e1827010&"
import script from "./SuccessRegister.vue?vue&type=script&lang=js&"
export * from "./SuccessRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports